import { apiFetcher } from '@gjensidige/service-async';
import { ProductsNumbers } from '../../types/enums/productsNumbers';
import { getText } from '../text/text-service';
import { isVillaagarna } from '../partners/partnersService';
import moment from 'moment';
interface ProductDocumentsLink {
    ipidLink: string;
    prePurchaseLink: string;
    termsAndConditionsLink: string;
}

export const getProductDocuments = async (
    productNumber: string,
    contractCode: string
) => {
    let productDocumentLinks = {
        ipidLink: '',
        prePurchaseLink: '',
        termsAndConditionsLink: ''
    };
    if (productNumber && contractCode) {
        const url = resolveDocumentUrl(productNumber, contractCode);
        let response: any = await apiFetcher.getJson(url);
        if (response.isOk()) {
            productDocumentLinks = getProductLinksFromResponse(response.value);
        }
    }
    console.log(productDocumentLinks);
    return productDocumentLinks;
};

const getProductLinksFromResponse = response => {
    console.log(response);

    return {
        ipidLink:
            response && response.ipidDocumentPath
                ? response.ipidDocumentPath[0]
                : '',
        prePurchaseLink:
            response &&
            response.prePurchaseInfos &&
            response.prePurchaseInfos.length > 0
                ? filterActiveDocument(response.prePurchaseInfos)
                : '',
        termsAndConditionsLink:
            response &&
            response.termsAndConditions &&
            response.termsAndConditions.length > 0
                ? filterActiveDocument(response.termsAndConditions)
                : ''
    };
};

const filterActiveDocument = (documentList: any) => {
    const currentDate = parseInt(moment().format('YYYYMMDD'));
    const activeDocument =
        documentList.find(
            (terms: any) =>
                terms.startDate &&
                terms.endDate &&
                parseInt(terms.startDate) <= currentDate &&
                currentDate < parseInt(terms.endDate)
        ) || '';
    return activeDocument && activeDocument.documentPath
        ? activeDocument.documentPath
        : '';
};

const resolveDocumentUrl = (productNumber: string, contractCode: string) => {
    return `/product-documents/documents/product-code/${productNumber}/contract-code/${contractCode}/current`;
};

export const replaceTextWithLinks = (
    labetText: string,
    documentLinks: ProductDocumentsLink
) => {
    if (documentLinks && labetText) {
        return labetText
            .replace('${ipidLink}', documentLinks.ipidLink)
            .replace(
                '${prePurchanseLink}',
                `${resolveCDNDir()}${documentLinks.prePurchaseLink}`
            )
            .replace(
                '${termsLink}',
                `${resolveCDNDir()}${documentLinks.termsAndConditionsLink}`
            );
    }
    return labetText;
};

export const resolveCDNDir = (): string => {
    if (window.location.hostname === 'localhost') {
        return 'https://cdn.testgjensidige.no/service-sweden/product-documents-se';
    } else if (window.location.hostname === 'www.testgjensidige.se') {
        return 'https://cdn.testgjensidige.no/service-sweden/product-documents-se';
    } else if (window.location.hostname === 'www.gjensidige.se') {
        return 'https://cdn.gjensidige.no/service-sweden/product-documents-se';
    } else if (window.location.hostname === 'beta.gjensidige.se') {
        return 'https://cdn.gjensidige.no/service-sweden/product-documents-se';
    } else {
        return 'https://cdn.testgjensidige.no/service-sweden/product-documents-se';
    }
};

export const resolveLabelWithLinks = (
    productNumber: string,
    documentLinks: ProductDocumentsLink
) => {
    switch (productNumber.toString()) {
        case ProductsNumbers.CAR:
            if (isVillaagarna()) {
                return replaceTextWithLinks(
                    getText(
                        'webshopsweden.products.car.dynamic.ipidLink.villaagarna'
                    ),
                    documentLinks
                );
            } else {
                return replaceTextWithLinks(
                    getText('webshopsweden.products.car.dynamic.ipidLink'),
                    documentLinks
                );
            }
        case ProductsNumbers.ACCIDENT:
            return replaceTextWithLinks(
                getText('webshopsweden.products.accident.dynamic.ipidLink'),
                documentLinks
            );
        case ProductsNumbers.EMPLOYEE_HEALTHCARE:
            return replaceTextWithLinks(
                getText(
                    'webshopsweden.products.employeeHealthcare.dynamic.ipidLink'
                ),
                documentLinks
            );
        case ProductsNumbers.HEM:
            if (isVillaagarna()) {
                return replaceTextWithLinks(
                    getText(
                        'webshopsweden.products.home.ipidLink.dynamic.villaagarna'
                    ),
                    documentLinks
                );
            } else {
                return replaceTextWithLinks(
                    getText('webshopsweden.products.home.dynamic.ipidLink'),
                    documentLinks
                );
            }
        case ProductsNumbers.COMPANY_CAR:
            return replaceTextWithLinks(
                getText('webshopsweden.products.companyCar.dynamic.ipidLink'),
                documentLinks
            );
        case ProductsNumbers.MOTORCYCLE:
            return isVillaagarna()
                ? replaceTextWithLinks(
                      getText(
                          'webshopsweden.products.motorcycle.villaagarna.dynamic.ipidLink'
                      ),
                      documentLinks
                  )
                : replaceTextWithLinks(
                      getText(
                          'webshopsweden.products.motorcycle.dynamic.ipidLink'
                      ),
                      documentLinks
                  );
        case ProductsNumbers.VILLA:
            return isVillaagarna()
                ? replaceTextWithLinks(
                      getText(
                          'webshopsweden.products.villaHome.villaagarna.dynamic.ipidLink'
                      ),
                      documentLinks
                  )
                : replaceTextWithLinks(
                      getText(
                          'webshopsweden.products.villaHome.dynamic.ipidLink'
                      ),
                      documentLinks
                  );
        default:
            return replaceTextWithLinks(
                getText('webshopsweden.products.car.dynamic.ipidLink'),
                documentLinks
            );
    }
};
